import platform from 'components/Trackers/platform'
import { useTracking } from 'utils/analytics/useTracking'

export const useAddressErrorTracking = () => {
  const track = useTracking(screenViewed)

  return {
    ctaTapped: (cta_title: string) =>
      track.buttonTapped({
        ...ctaTapped,
        cta_title,
      }),
  }
}

const sharedProps = {
  platform,
  card_type: 'moc',
  context: 'registration',
  screen: 'bankCardOrderAddressNotFound',
  screen_name: 'bankCardOrderAddressNotFound',
}

const screenViewed = {
  object: 'Screen',
  action: 'Viewed',
  object_name: 'bankCardOrderAddressNotFound',
  ...sharedProps,
}

const ctaTapped = {
  object: 'Button',
  action: 'Tapped',
  object_name: 'bankCardOrderAddressNotFoundPrimaryCTA',
  ...sharedProps,
}
